<template>
    <div class="custom_select">
        <span class="fa fa-times clear" v-if="allowEmpty && !disabled" @click.prevent="clear()"></span>
        <Multiselect
            v-model="model"
            :id="`select_${_uid}`"
            :multiple="multiple"
            :options="options"
            :allow-empty="false"
            :placeholder="placeholder"
            :custom-label="customLabel"
            :label="treatedLabel"
            :loading="loading"
            :track-by="treatedTrackBy"
            :block-keys="['Tab']"
            :disabled="disabled"
            :group-values="groupValues"
            :group-label="groupLabel"
            selectLabel=""
            selectedLabel=""
            deselectLabel=""
            @input="onChange"
        >
            <template slot="noResult">
                {{ $t('no_records_found') }}
            </template>
        </Multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import { trans } from 'utils/helpers/translation'
    import { find, isNull } from 'lodash'

    export default {
        components: { Multiselect },
        data () {
            return {
                model: ''
            }
        },
        props: {
            'value': {
                default: () => ''
            },
            'options': {
                type: Array,
                default: () => []
            },
            'placeholder': {
                type: String,
                default: () => trans('select_an_option')
            },
            'allowEmpty': {
                type: Boolean,
                default: () => true
            },
            'searchable': {
                type: Boolean,
                default: () => true
            },
            'multiple': {
                type: Boolean,
                default: () => false
            },
            'loading': {
                type: Boolean,
                default: () => false
            },
            'label': {
                type: String,
                default: () => ''
            },
            'trackBy': {
                type: String,
                default: () => ''
            },
            'groupLabel': {
                type: String,
                default: () => null
            },
            'groupValues': {
                type: String,
                default: () => null
            },
            'giveBack': {
                type: String,
                default: () => 'id'
            },
            'customLabel': {
                default: () => {}
            },
            'disabled': {
                type: Boolean,
                default: () => false
            }
        },
        mounted () {
            let main = find(this.options, { [this.groupValues]: [{ id: parseInt(this.value) }] }) || {}
            this.model = find(main[this.groupValues], { id: parseInt(this.value) })
        },
        watch: {
            value (val) {
                let main = find(this.options, { [this.groupValues]: [{ id: parseInt(val) }] }) || {}
                this.model = find(main[this.groupValues], { id: parseInt(val) })
            }
        },
        computed: {
            treatedTrackBy () {
                return this.trackBy === '' ? 'id' : this.trackBy
            },
            treatedLabel () {
                return this.label === '' ? 'name' : this.label
            }
        },
        methods: {
            onChange (value) {
                isNull(value) ? this.$emit('input', value) : this.$emit('input', value[this.giveBack])
            },
            clear () {
                this.model = ''
                this.$emit('input', null)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/SelectGroup.vue